import { PaymentMethod } from 'types';
import { baseQuery } from '../baseQuery';

type ProcessPaymentParams = {
  serviceId: string;
  paymentMethod: PaymentMethod;
};

export const postProcessPayment = async ({ serviceId, paymentMethod }: ProcessPaymentParams) => {
  const { data } = await baseQuery('process-payment', {
    type: 'POST',
    body: {
      payment_method: paymentMethod,
      job_id: parseInt(serviceId),
    },
  });

  return data as never[];
};
